// 困难生认定
export default [
    {
        path: '/graduatesLeavingBed',
        component: resolve => require(['@/pages/graduatesLeavingBed/graduatesLeavingBed.vue'], resolve),
        name: 'graduatesLeavingBed',
        meta: {
            title: '毕业生离寝'
        }
    },
    {
        path: '/graduatesLeavingBedDetail',
        component: resolve => require(['@/pages/graduatesLeavingBed/graduatesLeavingBedDetail.vue'], resolve),
        name: 'graduatesLeavingBedDetail',
        meta: {
            title: '毕业生离寝详情'
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/graduatesLeavingBed.js